import * as React from "react";
const SvgSend = (props) => /* @__PURE__ */ React.createElement(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    ...props
  },
  /* @__PURE__ */ React.createElement(
    "path",
    {
      d: "M8.58403 11.4121L16.7516 3.24752M8.81617 11.7793L10.6682 15.4833C11.1158 16.3784 11.3395 16.826 11.6214 16.946C11.8661 17.0501 12.1458 17.0313 12.3742 16.8953C12.6375 16.7385 12.7992 16.265 13.1226 15.3179L16.6219 5.06996C16.9036 4.24475 17.0445 3.83214 16.9481 3.55919C16.8642 3.32174 16.6774 3.13496 16.44 3.05106C16.167 2.95463 15.7544 3.09552 14.9292 3.3773L4.68128 6.87659C3.7342 7.19998 3.26066 7.36168 3.1039 7.62494C2.96786 7.8534 2.94901 8.13306 3.05316 8.37771C3.17318 8.65962 3.62074 8.8834 4.51585 9.33096L8.21989 11.183C8.36738 11.2567 8.44113 11.2936 8.50504 11.3429C8.56174 11.3866 8.61258 11.4374 8.65629 11.4941C8.70555 11.558 8.74243 11.6318 8.81617 11.7793Z",
      stroke: "#5A5F72",
      strokeWidth: 1.5,
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  )
);
export default SvgSend;
